<script lang="ts">
  import type { ShellController } from './shell-controller.svelte';
  import { socketState } from '../socket-state.svelte';
  import { WORLD_PICKER } from '../../game/constants/world';

  const { shell }: { shell: ShellController } = $props();

  /** Five fixed buttons; buckets past the fifth are ignored so world numbers never shift. */
  const worlds = $derived(
    Array.from({ length: WORLD_PICKER.worldCount }, (_, index) => ({
      index,
      bucket: socketState.worldPopulations[index] ?? 0,
    })),
  );
</script>

<div class="wis-panel wis-panel--worlds">
  <div class="worlds__grid">
    {#each worlds as world (world.index)}
      <button
        class="wis-btn-square worlds__world"
        type="button"
        aria-pressed={world.index === socketState.serverNum}
        onclick={() => {
          shell.chooseWorld(world.index);
        }}
      >
        {world.index + 1}
        <i
          class="wis-pop wis-pop--{world.bucket}"
          aria-label={WORLD_PICKER.bucketLabels[world.bucket] ?? WORLD_PICKER.bucketLabels[0]}
        ></i>
      </button>
    {/each}
  </div>

  <h2 class="wis-row worlds__heading">Population</h2>

  <ul class="worlds__legend">
    {#each WORLD_PICKER.bucketLabels as label, bucket (label)}
      <li class="worlds__key">
        <i class="wis-pop wis-pop--{bucket}"></i>
        <span>{label}</span>
      </li>
    {/each}
  </ul>

  <p class="worlds__note">You are on world {socketState.serverNum + 1}.</p>

  <button
    class="wis-btn worlds__back"
    type="button"
    onclick={() => {
      shell.navigate('pregame');
    }}>Back</button
  >
</div>

<style>
  .worlds__heading {
    top: 288px;
    margin: 0;
    color: var(--wis-ink);
    font-size: 17px;
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  .worlds__legend {
    position: absolute;
    top: 320px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 22px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .worlds__key {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--wis-ink);
    font-size: 12px;
    text-transform: uppercase;
  }

  .worlds__note {
    position: absolute;
    top: 358px;
    left: 0;
    right: 0;
    margin: 0;
    color: var(--wis-ink);
    font-size: 13px;
    text-transform: uppercase;
  }

  /* Menu_2's rails leave 24px of frame each side, and five buttons at the art's own 96px are
     wider than what is left. */
  .worlds__grid {
    position: absolute;
    top: 187px;
    left: 24px;
    right: 24px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }

  .worlds__world {
    width: 84px;
    height: 65px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .worlds__back {
    position: absolute;
    top: 470px;
    left: 150px;
    width: 200px;
    height: 54px;
    padding: 0;
    font-size: 16px;
  }
</style>
